 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLEPAGE from '@/components/xhtml/Titlepage'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLINTRODUCTION from '@/components/xhtml/Introduction'
 import XHTMLTRANSCRIPTIONS from '@/components/xhtml/Transcriptions'
 import XHTMLGENITITLE from '@/components/xhtml/Genititle'
 import XHTMLGENIFRONTMATTER from '@/components/xhtml/Genifrontmatter'
 import XHTMLCHAPTER01 from '@/components/xhtml/Chapter01'
 import XHTMLCHAPTER02 from '@/components/xhtml/Chapter02'
 import XHTMLCHAPTER03 from '@/components/xhtml/Chapter03'
 import XHTMLCHAPTER04 from '@/components/xhtml/Chapter04'
 import XHTMLCHAPTER05 from '@/components/xhtml/Chapter05'
 import XHTMLCHAPTER06 from '@/components/xhtml/Chapter06'
 import XHTMLCHAPTER07 from '@/components/xhtml/Chapter07'
 import XHTMLCHAPTER08 from '@/components/xhtml/Chapter08'
 import XHTMLCHAPTER09 from '@/components/xhtml/Chapter09'
 import XHTMLCHAPTER10 from '@/components/xhtml/Chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/Chapter11'
 import XHTMLCHAPTER12 from '@/components/xhtml/Chapter12'
 import XHTMLCHAPTER13 from '@/components/xhtml/Chapter13'
 import XHTMLCHAPTER14 from '@/components/xhtml/Chapter14'
 import XHTMLCHAPTER15 from '@/components/xhtml/Chapter15'
 import XHTMLCHAPTER16 from '@/components/xhtml/Chapter16'
 import XHTMLCHAPTER17 from '@/components/xhtml/Chapter17'
 import XHTMLCHAPTER18 from '@/components/xhtml/Chapter18'
 import XHTMLCHAPTER19 from '@/components/xhtml/Chapter19'
 import XHTMLCHAPTER20 from '@/components/xhtml/Chapter20'
 import XHTMLCHAPTER21 from '@/components/xhtml/Chapter21'
 import XHTMLCHAPTER22 from '@/components/xhtml/Chapter22'
 import XHTMLCHAPTER23 from '@/components/xhtml/Chapter23'
 import XHTMLCHAPTER24 from '@/components/xhtml/Chapter24'
 import XHTMLCHAPTER25 from '@/components/xhtml/Chapter25'
 import XHTMLCHAPTER26 from '@/components/xhtml/Chapter26'
 import XHTMLCHAPTER27 from '@/components/xhtml/Chapter27'
 import XHTMLCHAPTER28 from '@/components/xhtml/Chapter28'
 import XHTMLCHAPTER29 from '@/components/xhtml/Chapter29'
 import XHTMLCHAPTER30 from '@/components/xhtml/Chapter30'
 import XHTMLCHAPTER31 from '@/components/xhtml/Chapter31'
 import XHTMLCHAPTER32 from '@/components/xhtml/Chapter32'
 import XHTMLCHAPTER33 from '@/components/xhtml/Chapter33'
 import XHTMLCHAPTER34 from '@/components/xhtml/Chapter34'
 import XHTMLCHAPTER35 from '@/components/xhtml/Chapter35'
 import XHTMLCHAPTER36 from '@/components/xhtml/Chapter36'
 import XHTMLCHAPTER37 from '@/components/xhtml/Chapter37'
 import XHTMLCHAPTER38 from '@/components/xhtml/Chapter38'
 import XHTMLCHAPTER39 from '@/components/xhtml/Chapter39'
 import XHTMLCHAPTER40 from '@/components/xhtml/Chapter40'
 import XHTMLCHAPTER41 from '@/components/xhtml/Chapter41'
 import XHTMLCHAPTER42 from '@/components/xhtml/Chapter42'
 import XHTMLCHAPTER43 from '@/components/xhtml/Chapter43'
 import XHTMLCHAPTER44 from '@/components/xhtml/Chapter44'
 import XHTMLCHAPTER45 from '@/components/xhtml/Chapter45'
 import XHTMLCHAPTER46 from '@/components/xhtml/Chapter46'
 import XHTMLCHAPTER47 from '@/components/xhtml/Chapter47'
 import XHTMLCHAPTER48 from '@/components/xhtml/Chapter48'
 import XHTMLCHAPTER49 from '@/components/xhtml/Chapter49'
 import XHTMLCHAPTER50 from '@/components/xhtml/Chapter50'
 import XHTMLEXOTITLE from '@/components/xhtml/exotitle'
 import XHTMLEXOFRONTMATTER from '@/components/xhtml/Exofrontmatter'
 import XHTMLEXODUS01 from '@/components/xhtml/Exodus01'
 import XHTMLEXODUS02 from '@/components/xhtml/Exodus02'
 import XHTMLEXODUS03 from '@/components/xhtml/Exodus03'
 import XHTMLEXODUS04 from '@/components/xhtml/Exodus04'
 import XHTMLEXODUS05 from '@/components/xhtml/Exodus05'
 import XHTMLEXODUS06 from '@/components/xhtml/Exodus06'
 import XHTMLEXODUS07 from '@/components/xhtml/Exodus07'
 import XHTMLEXODUS08 from '@/components/xhtml/Exodus08'
 import XHTMLEXODUS09 from '@/components/xhtml/Exodus09'
 import XHTMLEXODUS10 from '@/components/xhtml/Exodus10'
 import XHTMLEXODUS11 from '@/components/xhtml/Exodus11'
 import XHTMLEXODUS12 from '@/components/xhtml/Exodus12'
 import XHTMLEXODUS13 from '@/components/xhtml/Exodus13'
 import XHTMLEXODUS14 from '@/components/xhtml/Exodus14'
 import XHTMLEXODUS15 from '@/components/xhtml/Exodus15'
 import XHTMLEXODUS16 from '@/components/xhtml/Exodus16'
 import XHTMLEXODUS17 from '@/components/xhtml/Exodus17'
 import XHTMLEXODUS18 from '@/components/xhtml/Exodus18'
 import XHTMLEXODUS19 from '@/components/xhtml/Exodus19'
 import XHTMLEXODUS20 from '@/components/xhtml/Exodus20'
 import XHTMLEXODUS21 from '@/components/xhtml/Exodus21'
 import XHTMLEXODUS22 from '@/components/xhtml/Exodus22'
 import XHTMLEXODUS23 from '@/components/xhtml/Exodus23'
 import XHTMLEXODUS24 from '@/components/xhtml/Exodus24'
 import XHTMLEXODUS25 from '@/components/xhtml/Exodus25'
 import XHTMLEXODUS26 from '@/components/xhtml/Exodus26'
 import XHTMLEXODUS27 from '@/components/xhtml/Exodus27'
 import XHTMLEXODUS28 from '@/components/xhtml/Exodus28'
 import XHTMLEXODUS29 from '@/components/xhtml/Exodus29'
 import XHTMLEXODUS30 from '@/components/xhtml/Exodus30'
 import XHTMLEXODUS31 from '@/components/xhtml/Exodus31'
 import XHTMLEXODUS32 from '@/components/xhtml/Exodus32'
 import XHTMLEXODUS33 from '@/components/xhtml/Exodus33'
 import XHTMLEXODUS34 from '@/components/xhtml/Exodus34'
 import XHTMLEXODUS35 from '@/components/xhtml/Exodus35'
 import XHTMLEXODUS36 from '@/components/xhtml/Exodus36'
 import XHTMLEXODUS37 from '@/components/xhtml/Exodus37'
 import XHTMLEXODUS38 from '@/components/xhtml/Exodus38'
 import XHTMLEXODUS39 from '@/components/xhtml/Exodus39'
 import XHTMLEXODUS40 from '@/components/xhtml/Exodus40'
 import XHTMLLEV_TITLE from '@/components/xhtml/Lev_Title'
 import XHTMLLEV_FRONT from '@/components/xhtml/Lev_Front'
 import XHTMLLEV_CHAPTER01 from '@/components/xhtml/Lev_Chapter01'
 import XHTMLLEV_CHAPTER02 from '@/components/xhtml/Lev_Chapter02'
 import XHTMLLEV_CHAPTER03 from '@/components/xhtml/Lev_Chapter03'
 import XHTMLLEV_CHAPTER04 from '@/components/xhtml/Lev_Chapter04'
 import XHTMLLEV_CHAPTER05 from '@/components/xhtml/Lev_Chapter05'
 import XHTMLLEV_CHAPTER06 from '@/components/xhtml/Lev_Chapter06'
 import XHTMLLEV_CHAPTER07 from '@/components/xhtml/Lev_Chapter07'
 import XHTMLLEV_CHAPTER08 from '@/components/xhtml/Lev_Chapter08'
 import XHTMLLEV_CHAPTER09 from '@/components/xhtml/Lev_Chapter09'
 import XHTMLLEV_CHAPTER10 from '@/components/xhtml/Lev_Chapter10'
 import XHTMLLEV_CHAPTER11 from '@/components/xhtml/Lev_Chapter11'
 import XHTMLLEV_CHAPTER12 from '@/components/xhtml/Lev_Chapter12'
 import XHTMLLEV_CHAPTER13 from '@/components/xhtml/Lev_Chapter13'
 import XHTMLLEV_CHAPTER14 from '@/components/xhtml/Lev_Chapter14'
 import XHTMLLEV_CHAPTER15 from '@/components/xhtml/Lev_Chapter15'
 import XHTMLLEV_CHAPTER16 from '@/components/xhtml/Lev_Chapter16'
 import XHTMLLEV_CHAPTER17 from '@/components/xhtml/Lev_Chapter17'
 import XHTMLLEV_CHAPTER18 from '@/components/xhtml/Lev_Chapter18'
 import XHTMLLEV_CHAPTER19 from '@/components/xhtml/Lev_Chapter19'
 import XHTMLLEV_CHAPTER20 from '@/components/xhtml/Lev_Chapter20'
 import XHTMLLEV_CHAPTER21 from '@/components/xhtml/Lev_Chapter21'
 import XHTMLLEV_CHAPTER22 from '@/components/xhtml/Lev_Chapter22'
 import XHTMLLEV_CHAPTER23 from '@/components/xhtml/Lev_Chapter23'
 import XHTMLLEV_CHAPTER24 from '@/components/xhtml/Lev_Chapter24'
 import XHTMLLEV_CHAPTER25 from '@/components/xhtml/Lev_Chapter25'
 import XHTMLLEV_CHAPTER26 from '@/components/xhtml/Lev_Chapter26'
 import XHTMLLEV_CHAPTER27 from '@/components/xhtml/Lev_Chapter27'
 import XHTMLNUM_TITLE from '@/components/xhtml/Num_Title'
 import XHTMLNUM_FRONT from '@/components/xhtml/Num_Front'
 import XHTMLNUMBERS01 from '@/components/xhtml/Numbers01'
 import XHTMLNUMBERS02 from '@/components/xhtml/Numbers02'
 import XHTMLNUMBERS03 from '@/components/xhtml/Numbers03'
 import XHTMLNUMBERS04 from '@/components/xhtml/Numbers04'
 import XHTMLNUMBERS05 from '@/components/xhtml/Numbers05'
 import XHTMLNUMBERS06 from '@/components/xhtml/Numbers06'
 import XHTMLNUMBERS07 from '@/components/xhtml/Numbers07'
 import XHTMLNUMBERS08 from '@/components/xhtml/Numbers08'
 import XHTMLNUMBERS09 from '@/components/xhtml/Numbers09'
 import XHTMLNUMBERS10 from '@/components/xhtml/Numbers10'
 import XHTMLNUMBERS11 from '@/components/xhtml/Numbers11'
 import XHTMLNUMBERS12 from '@/components/xhtml/Numbers12'
 import XHTMLNUMBERS13 from '@/components/xhtml/Numbers13'
 import XHTMLNUMBERS14 from '@/components/xhtml/Numbers14'
 import XHTMLNUMBERS15 from '@/components/xhtml/Numbers15'
 import XHTMLNUMBERS16 from '@/components/xhtml/Numbers16'
 import XHTMLNUMBERS17 from '@/components/xhtml/Numbers17'
 import XHTMLNUMBERS18 from '@/components/xhtml/Numbers18'
 import XHTMLNUMBERS19 from '@/components/xhtml/Numbers19'
 import XHTMLNUMBERS20 from '@/components/xhtml/Numbers20'
 import XHTMLNUMBERS21 from '@/components/xhtml/Numbers21'
 import XHTMLNUMBERS22 from '@/components/xhtml/Numbers22'
 import XHTMLNUMBERS23 from '@/components/xhtml/Numbers23'
 import XHTMLNUMBERS24 from '@/components/xhtml/Numbers24'
 import XHTMLNUMBERS25 from '@/components/xhtml/Numbers25'
 import XHTMLNUMBERS26 from '@/components/xhtml/Numbers26'
 import XHTMLNUMBERS27 from '@/components/xhtml/Numbers27'
 import XHTMLNUMBERS28 from '@/components/xhtml/Numbers28'
 import XHTMLNUMBERS29 from '@/components/xhtml/Numbers29'
 import XHTMLNUMBERS30 from '@/components/xhtml/Numbers30'
 import XHTMLNUMBERS31 from '@/components/xhtml/Numbers31'
 import XHTMLNUMBERS32 from '@/components/xhtml/Numbers32'
 import XHTMLNUMBERS33 from '@/components/xhtml/Numbers33'
 import XHTMLNUMBERS34 from '@/components/xhtml/Numbers34'
 import XHTMLNUMBERS35 from '@/components/xhtml/Numbers35'
 import XHTMLNUMBERS36 from '@/components/xhtml/Numbers36'
 import XHTMLDEUTITLE from '@/components/xhtml/Deutitle'
 import XHTMLDEUFRONTMATTER from '@/components/xhtml/Deufrontmatter'
 import XHTMLDEUTERONOMY01 from '@/components/xhtml/Deuteronomy01'
 import XHTMLDEUTERONOMY02 from '@/components/xhtml/Deuteronomy02'
 import XHTMLDEUTERONOMY03 from '@/components/xhtml/Deuteronomy03'
 import XHTMLDEUTERONOMY04 from '@/components/xhtml/Deuteronomy04'
 import XHTMLDEUTERONOMY05 from '@/components/xhtml/Deuteronomy05'
 import XHTMLDEUTERONOMY06 from '@/components/xhtml/Deuteronomy06'
 import XHTMLDEUTERONOMY07 from '@/components/xhtml/Deuteronomy07'
 import XHTMLDEUTERONOMY08 from '@/components/xhtml/Deuteronomy08'
 import XHTMLDEUTERONOMY09 from '@/components/xhtml/Deuteronomy09'
 import XHTMLDEUTERONOMY10 from '@/components/xhtml/Deuteronomy10'
 import XHTMLDEUTERONOMY11 from '@/components/xhtml/Deuteronomy11'
 import XHTMLDEUTERONOMY12 from '@/components/xhtml/Deuteronomy12'
 import XHTMLDEUTERONOMY13 from '@/components/xhtml/Deuteronomy13'
 import XHTMLDEUTERONOMY14 from '@/components/xhtml/Deuteronomy14'
 import XHTMLDEUTERONOMY15 from '@/components/xhtml/Deuteronomy15'
 import XHTMLDEUTERONOMY16 from '@/components/xhtml/Deuteronomy16'
 import XHTMLDEUTERONOMY17 from '@/components/xhtml/Deuteronomy17'
 import XHTMLDEUTERONOMY18 from '@/components/xhtml/Deuteronomy18'
 import XHTMLDEUTERONOMY19 from '@/components/xhtml/Deuteronomy19'
 import XHTMLDEUTERONOMY20 from '@/components/xhtml/Deuteronomy20'
 import XHTMLDEUTERONOMY21 from '@/components/xhtml/Deuteronomy21'
 import XHTMLDEUTERONOMY22 from '@/components/xhtml/Deuteronomy22'
 import XHTMLDEUTERONOMY23 from '@/components/xhtml/Deuteronomy23'
 import XHTMLDEUTERONOMY24 from '@/components/xhtml/Deuteronomy24'
 import XHTMLDEUTERONOMY25 from '@/components/xhtml/Deuteronomy25'
 import XHTMLDEUTERONOMY26 from '@/components/xhtml/Deuteronomy26'
 import XHTMLDEUTERONOMY27 from '@/components/xhtml/Deuteronomy27'
 import XHTMLDEUTERONOMY28 from '@/components/xhtml/Deuteronomy28'
 import XHTMLDEUTERONOMY29 from '@/components/xhtml/Deuteronomy29'
 import XHTMLDEUTERONOMY30 from '@/components/xhtml/Deuteronomy30'
 import XHTMLDEUTERONOMY31 from '@/components/xhtml/Deuteronomy31'
 import XHTMLDEUTERONOMY32 from '@/components/xhtml/Deuteronomy32'
 import XHTMLDEUTERONOMY33 from '@/components/xhtml/Deuteronomy33'
 import XHTMLDEUTERONOMY34 from '@/components/xhtml/Deuteronomy34'
 import XHTMLEPILOGUES from '@/components/xhtml/Epilogues'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLACKNOWLEDGMENTS from '@/components/xhtml/Acknowledgments'
 import XHTMLEXODUS_BA from '@/components/xhtml/Exodus_BA'
 import XHTMLNOTES from '@/components/xhtml/Notes'
 import XHTMLOTHERWORKS from '@/components/xhtml/Otherworks'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLABOUTTHEPUBLISHER from '@/components/xhtml/Aboutthepublisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js